import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";
export const API = `${BACKEND_URL}/api`;

// Cookies (httpOnly, secure, samesite=none) carry the session.
// We avoid localStorage to reduce XSS surface area.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 8000,
});

export function fileUrl(pathOrUrl) {
  if (!pathOrUrl) return null;
  if (pathOrUrl.startsWith("http")) return pathOrUrl;
  if (pathOrUrl.startsWith("/api/")) return `${BACKEND_URL}${pathOrUrl}`;
  if (pathOrUrl.startsWith("/")) return pathOrUrl;
  return `${API}/files/${pathOrUrl}`;
}
